export function createDummyAsyncIterator<T>(
  defaultValue: T,
): AsyncIterator<T, T, unknown> & AsyncIterable<T> {
  return {
    async next() {
      return { value: defaultValue, done: false }
    },
    [Symbol.asyncIterator]() {
      return this
    },
  }
}
